import React, {Component} from 'react';
import {toJS,autorun} from 'mobx';
import {autobind} from 'core-decorators';
import SearchPlan from '../component/SearchPlan';
import PropTypes from 'prop-types';
import './SearchPageView.less';
var mobx = require('mobx');
import {observer} from "mobx-react";
import stores from '../../../stores';
const {queryStore} = stores;

@observer
class SearchPageView extends Component{

  constructor(props) {
    super(props);

    this.SearchClickFlag = true;
    this.winHeight=window.innerHeight;
    window.addEventListener("resize", this.resize);
  }

  componentWillMount(){
    const {planInfo} =  this.props;
    queryStore.init(planInfo);
  }

  componentDidMount(){
    this.disposer = autorun(() => queryStore.searchModel && queryStore.searchModel.load(true));
  }

  componentWillUnmount() {
    this.disposer();
  }

  pageBackReceiveResult = (result, params) => {
    if('ok'===result){
        let {
          type,
          code,
          mode,
          selecteds,
          refObject
        } = params;
        selecteds = selecteds || [];
        if (type === 'refOK') {
          const planItem = queryStore.searchModel.items.find(it => it.code === code);
          if (planItem) {
            if (mode === 'range') {
              if (selecteds.length===0){
                selecteds = [null];
              }
              selecteds = [selecteds[selecteds.length - 1]];
              planItem.setValue(selecteds.concat(selecteds), refObject);
            } else if (mode === 'single') {
              planItem.setValue(selecteds[selecteds.length - 1], refObject);
            }else{
              planItem.setValue(selecteds, refObject);
            }
          }
        }
    }
  }

  reset = () => {
    queryStore.searchModel.items.forEach(item => {
      console.log(item)
      if (item.component === 'refBox') {
        if (item.mode === 'range') {
          item.setValue([null, null]);
        } else if (item.mode === 'single') {
          item.setValue(null);
        }else{
          item.setValue([]);
        }
      } else {
        if (item.mode === 'single') {
          item.setValue({text: '', value: ''});
        } else {
          item.setValue([{text: '', value: ''}, {text: '', value: ''}])
        }
      }
    })
  }



  save = (callBack) => {
    if(this.SearchClickFlag) {
      this.SearchClickFlag = false;
      //console.log('this.props.store.report==================',mobx.toJS(this.props.store.report));
      queryStore.searchModel.save().then(success => {
        if (success) {
          this.context.popAndReturn('ok',{type:'refresh',planId:queryStore.currentPlanId});
        }
        setTimeout(() => {this.SearchClickFlag = true}, 500)
      });
    }
  }

  render() {
    const searchPlan = queryStore.searchModel;
    if(!searchPlan || searchPlan.items.length == 0){
      return null;
    }
    return (<SearchPlan items={searchPlan.items} callBack={this.pageBackReceiveResult} />);
  }

    //键盘弹出时处理事件
    @autobind
    resize(){
      var _this=this;
        if(document.activeElement.tagName=="INPUT" || document.activeElement.tagName=="TEXTAREA") {
             window.setTimeout(this.scrollIntoView,0);
         }
         window.setTimeout(function(){
          _this.isKeyboard=Math.abs(window.innerHeight-_this.winHeight)>50;
         },200);
    }

    //键盘弹出时处理事件
    @autobind
    scrollIntoView(){
       document.activeElement.scrollIntoViewIfNeeded();
    }
}

SearchPageView.contextTypes = {
  pop:PropTypes.func,
  push:PropTypes.func,
  pushForResult:PropTypes.func,
  pageParam:PropTypes.func,
  popAndReturn:PropTypes.func,
  replace:PropTypes.func
}


export default SearchPageView;
